import { LiveBookingsHeader } from '@eatclub-apps/ec-bookings-library';
import { Box } from '@eatclubcode/ec-component-library';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
// import AppHeader from '../components/layout/appHeader/AppHeader';
import CustomHeader from '../components/Layout/appHeader/CustomHeader';
import useStyles from '../components/Layout/navigation/NavigationStyles';
import RestaurantSwitcher from '../components/Layout/navigation/RestaurantSwitcher';
import { restaurantPropTypes } from '../data/models/Restaurant';
import routes from '../routes/Routes';

const AppLayout = ({ premium, children, restaurantActive }) => {
  const location = useLocation();
  const classes = useStyles();

  const premiumLabel = (name) => (
    <div className={classes.flex}>
      <div style={{ opacity: '0.4' }}>{name}</div>
      <div className={classes.premiumLabel}>Premium</div>
    </div>
  );

  // This is the navigation in the container app rather than the in-bookings navigation
  const getNavigationItems = () => {
    return [
      {
        name: 'Run Sheet',
        slug: 'runsheet',
      },
      {
        name: premium ? 'Floor plan' : premiumLabel('Floor plan'),
        slug: 'floorplan',
      },
      {
        name: premium ? 'Timeline' : premiumLabel('Timeline'),
        slug: 'timeline',
      },
      {
        name: 'Guestbook',
        slug: 'guestbook',
      },
      {
        name: 'Voucher Redemption',
        slug: 'voucher-redemptions',
      },
      {
        name: 'Settings',
        slug: 'settings',
      },
    ];
  };

  const [navigationItems, setNavigationItems] = useState(getNavigationItems());

  useEffect(() => {
    setNavigationItems(getNavigationItems());
  }, [premium]);

  const route = routes.find((routeToFind) => matchPath(location.pathname, routeToFind));

  // Set title and header
  useEffect(() => {
    const pageTitle = route?.pageTitle || 'Dashboard';
    const titleDelimiter = pageTitle !== '' ? ' | ' : '';
    const titleEnd = `${import.meta.env.VITE_WEBSITE_NAME}`;

    const restaurantName = restaurantActive?.restaurant?.name;

    window.document.title = [restaurantName, pageTitle, titleEnd]
      ?.filter((i) => !!i)
      ?.join(titleDelimiter);
  }, [location.pathname, navigationItems]);

  const [showRestaurantSwitcher, setShowRestaurantSwitcher] = useState(false);
  const [restaurantSwitcherAnchor, setRestaurantSwitcherAnchor] = useState(null);

  const handleDrawerOpen = (e) => {
    setShowRestaurantSwitcher(true);
    setRestaurantSwitcherAnchor(e?.currentTarget);
  };

  const renderHeader = () => {
    // // TODO replace this with something else, but ideally don't render ec bookings until a rest ID is set
    // // TODO also handle if you're staff and no restaurant is set
    // // TODO can optimize further if restaurant id is stored in local state
    // if (!restId) {
    //   return <Box>Loading....</Box>;
    // }

    if (restaurantActive?.restaurantFetching) {
      return <Box />;
    }

    switch (route?.header) {
      case 'custom':
        return (
          <CustomHeader
            openDrawer={(e) => handleDrawerOpen(e)}
            showNavigation={(e) => handleDrawerOpen(e)}
            navigationOpen={false}
          >
            {children}
          </CustomHeader>
        );
      case 'obee':
      default:
        return (
          <LiveBookingsHeader
            openDrawer={handleDrawerOpen}
            showNavigation={handleDrawerOpen}
            navigationOpen={false}
            pageId={route?.id}
            hideFilters={route?.hideFilters}
          >
            {children}
          </LiveBookingsHeader>
        );
    }
  };

  return (
    <>
      <RestaurantSwitcher
        isOpen={showRestaurantSwitcher}
        onClose={() => setShowRestaurantSwitcher(false)}
        anchor={restaurantSwitcherAnchor}
      />
      {renderHeader()}
    </>
  );
};

AppLayout.defaultProps = {
  premium: true,
  restaurantActive: null,
  children: null,
};

AppLayout.propTypes = {
  premium: PropTypes.bool,
  children: PropTypes.node,
  restaurantActive: restaurantPropTypes,
};

const mapStateToProps = (state) => ({
  premium: state.restaurantActive.restaurant?.premium,
  restId: state.restaurantActive.restaurant.objectId,
  restaurantActive: state.restaurantActive,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
